import { Button, IconButton, Stack } from "@chakra-ui/react";
import { Key } from "react";

import { DeleteIcon } from "../Icons/Icons";

export interface EditableListProperties<T> {
  addItemButtonLabel?: string;
  getKey?: (item: T, index: number) => Key;
  isDisabled?: boolean;
  items: T[];
  onAddItem?: () => void;
  onRemoveItem?: (item: T, index: number) => void;
  renderItem: (item: T, index: number) => React.ReactNode;
}

export const EditableList = <T,>({
  addItemButtonLabel = "Nouveau",
  getKey = (_item, index) => index,
  isDisabled = false,
  items,
  onAddItem,
  onRemoveItem,
  renderItem,
}: EditableListProperties<T>): React.ReactElement => {
  return (
    <Stack>
      {items.map((item, index) => (
        <Stack direction="row" key={getKey(item, index)}>
          {renderItem(item, index)}
          <IconButton
            aria-label="Remove"
            borderRadius="lg"
            colorScheme="danger"
            icon={<DeleteIcon />}
            onClick={() => onRemoveItem?.(item, index)}
          />
        </Stack>
      ))}
      {onAddItem != null && (
        <Button colorScheme="info" disabled={isDisabled} m={0} onClick={() => onAddItem()} type="button" w="100%">
          {addItemButtonLabel}
        </Button>
      )}
    </Stack>
  );
};
